module.exports = __webpack_public_path__ + "img/icons B_1.e137dc18.svg";